import script from "./RegisterWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterWizard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__